// extracted by mini-css-extract-plugin
export default {"MONTH":"VzccFE","month":"VzccFE","DAY":"ZpGZPy","day":"ZpGZPy","YEAR":"umLonC","year":"umLonC","fields":"Roix5c","mobile":"zZLgkT"};